"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildApplicantRefined = void 0;
const __1 = require("..");
const buildApplicantRefined = (applicant, applications = [], credentials = []) => ({
    ID: applicant.ID,
    metadata: { created: applicant.metadata.created, updated: applicant.metadata.updated },
    title: applicant.title,
    givenName: applicant.givenName,
    otherGivenName: applicant.otherGivenName,
    familyName: applicant.familyName,
    dateOfBirth: applicant.dateOfBirth,
    type: applicant.type,
    gender: applicant.gender,
    countryOfBirth: applicant.countryOfBirth,
    citizenship: applicant.citizenship,
    residencyStatus: applicant.residencyStatus,
    address: applicant.address,
    contactPhoneNumber: applicant.contactPhoneNumber,
    emailAddress: applicant.emailAddress,
    institutionIdentifier: applicant.institutionIdentifier,
    customAttributes: applicant.customAttributes,
    applications: applications.map((application) => (0, __1.buildApplicationRefined)(application)),
    credentials: credentials.map(__1.buildCredentialRefined),
});
exports.buildApplicantRefined = buildApplicantRefined;
//# sourceMappingURL=ApplicantRefined.js.map